import { memo, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import dayjs from 'dayjs';

export default memo(function NewsWeather({ pageTitle, onlyBread = false, style }) {
  const navRef = useRef();

  const today = dayjs.tz();
  const weekDay = dayjs.localeData().weekdays();
  const monthDay = dayjs.localeData().months();

  const date = today.date();
  const week = weekDay[today.day()];
  const month = monthDay[today.month()];

  useEffect(() => {
    navRef.current.querySelector('li:last-child').setAttribute('aria-current', 'page');
  }, []);

  return (
    <section className="news-head" style={style}>
      <nav className="breadcrumb" aria-label="Breadcrumb" ref={navRef}>
        <ol>
          <li>
            <Link to="/">HOME</Link>
          </li>
          <li>
            <Link to="/news">NEWS</Link>
          </li>
          {!!pageTitle && (
            <li>
              <span>{pageTitle}</span>
            </li>
          )}
        </ol>
      </nav>
      {!onlyBread && (
        <div className="weather">
          <iframe
            src="https://hosts.weatheri.co.kr/arirangtv/ariban2.php"
            title="weather local"
            scrolling="no"
            border="no"
            className="weather_iframe"
          />
          <iframe
            src="https://hosts.weatheri.co.kr/arirangtv/ariban3.php"
            title="weather global"
            scrolling="no"
            border="no"
            className="weather_iframe"
          />
          <span className="date">{`${week}, ${date} ${month}`}</span>
        </div>
      )}
    </section>
  );
});
